export const getTfForm = formId => {
  return axios.get(`/api/v3/typeform/forms/${formId}`);
};

export const getTfResponse = (formId, responseId) => {
  return axios.get(`/api/v3/typeform/forms/${formId}/responses/${responseId}`);
};
